import { useErrorHandler, useTranslate } from '@repo/shared/hooks'
import { FormSchema, useAppForm } from '@repo/ui/hooks'
import { useRef } from 'react'

import { useLoginSchema } from '@repo/auth/schemas'
import { handleNumericInput, handlePasteInput } from '@repo/tools'
import { usePhoneOtp } from '@repo/services'
import {
  Alert,
  Button,
  Form,
  FormField,
  FormItemWrapper,
  Input,
} from '@repo/ui/components'
import { normalizeMobile } from '@repo/ui/lib'
import { IChangeMobileKycFormProps } from './change-mobile-kyc.types'

export const ChangeMobileKycForm = (props: IChangeMobileKycFormProps) => {
  const { onSuccess, mobile } = props
  const { t } = useTranslate()
  const { mobileSchema } = useLoginSchema()
  const ref = useRef<HTMLFormElement>(null)

  const { form } = useAppForm({
    formSchema: mobileSchema,
    defaultValues: {
      mobile: mobile,
    },
  })
  const phoneOtpMutation = usePhoneOtp()
  const { errorHandler } = useErrorHandler()

  const onSubmit = (data: FormSchema<typeof mobileSchema>) => {
    phoneOtpMutation.mutate(
      { phone: normalizeMobile(data.mobile) },
      {
        onSuccess: (res) => onSuccess(data.mobile, res?.data?.otp ?? 0),
        onError: errorHandler,
      },
    )
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className='overflow-y-auto scrollbar-hide space-y-3xl w-full px-[2px]'
        ref={ref}
      >
        <Alert color='base' caption={t('changeMobileKyc_alert')} hideIcon />
        <FormField
          control={form.control}
          name='mobile'
          render={({ field }) => (
            <FormItemWrapper
              title={t('common_mobileNumber')}
              caption={t('changeMobileKyc_mobileStartsWithZero')}
              inputSize='lg'
            >
              <Input
                autoComplete='off'
                type='text'
                className='ltr !min-h-[50px] !max-h-[50px]'
                inputSize='lg'
                variant={'fill'}
                {...field}
                onKeyDown={(e) => handleNumericInput(e, 11)}
                onPaste={(e) => handlePasteInput(e, 11)}
                onClick={() => {
                  setTimeout(() => {
                    ref.current?.scrollBy({ behavior: 'smooth', top: 100 })
                  }, 600)
                }}
              />
            </FormItemWrapper>
          )}
        />
        <Button
          className='w-full'
          type='submit'
          variant='ghost'
          size='md'
          color='base'
          loading={phoneOtpMutation.isPending}
        >
          {t('common_continue')}
        </Button>
      </form>
    </Form>
  )
}
